import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import Skeleton from '../../../Skeleton/Skeleton';

import styles from './Section.scss';

interface Props {
  alignment?: 'right' | 'left';
  children: React.ReactNode;
  showSkeleton?: boolean;
  translation?: TranslationTag;
}
const Section: React.FC<Props> = ({ alignment = 'left', children, showSkeleton, translation }) => (
  <div className={classNames(styles.root, styles[alignment])}>
    <div className={styles.title}>
      {showSkeleton ? (
        <Skeleton variant="text" sx={{ width: 150 }} />
      ) : (
        translation && <Translation tagName="h3" {...translation} />
      )}
    </div>
    <div className={styles.content}>
      {showSkeleton ? <Skeleton sx={{ height: 300, width: 300 }} /> : children}
    </div>
  </div>
);

export default Section;
